import React from 'react';
import VkIcon from '../../Icons/Vk';
import {bindActionCreators, compose} from 'redux';
import * as authActions from '../../../actions/authActionsCreators';
import {connect} from 'react-redux';

import './style.scss';
import TgIcon from '../../Icons/Tg';

const SocialNetworks = (props) => {

 const
   {current_user, is_mobile, current_city, system_settings} = props.applicationState,
   tgChannelUrl = 'https://t.me/perviystroysentr',
   vkGroupUrl = 'https://vk.com/club80451203';
 return (
   <div className='footer__social-networks'>
     <a href={vkGroupUrl} target="_blank"><VkIcon size={is_mobile ? 48 : 40} /></a>
     <a href={tgChannelUrl} target="_blank"><TgIcon size={is_mobile ? 48 : 40} /> </a>
   </div>
 );
}

const
  mapDispatchToProps = (dispatch) => {
    return {
      authActions: bindActionCreators(authActions, dispatch),
    };
  },
  mapStateToProps = ({applicationState, railsContext}) => {
    return {
      applicationState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default compose(withConnect)(SocialNetworks);
